import React, { FC } from 'react'
import _ from 'lodash'
// Components
import { field_attrs } from "components/table/lib/column-field"
import DropdownInput from "components/inputs/dropdown"
// Data
import propertyService from "data/property"
// Styles
import { H4, Label_s } from "styles/app-styles"
import { Defaults_s } from "components/property/defaults/defaults-styles"

interface DefaultsRentRollProps {
  property: object
  increaseData: object[]
  inflationData: object[]
  marketLeaseData: object[]
  payoutData: object[]
}

const DefaultsRentRoll: FC<DefaultsRentRollProps> = (props) => {
  const { property, increaseData, inflationData, marketLeaseData, payoutData } = props;


  const persist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsrentroll'];
    if (field === 'marketLease') val = Number(val)
    data[field] = val;
    propertyService.patch(nextProperty)
  }

  const namedItemPersist = (field, val) => {
    const nextProperty = _.cloneDeep(property);
    let data = nextProperty['defaultsrentroll'];
    _.set(data, field, Number(val))
    propertyService.patch(nextProperty)
  }

  const data = property['defaultsrentroll'] || {};

  const attrs = (field) => field_attrs('property', 'defaultsrentroll')(field)(property, props)

  return property && !_.isEmpty(data) ? (
    <Defaults_s>
      <div>
        <H4>General</H4>
        <hr />
        <div>
          <div>
            <Label_s>Status</Label_s>
            <DropdownInput
              field="status"
              options={['Contractual', 'Speculative'].map(opt => { return {'label': opt, 'value': opt}})}
              value={data['status']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Type</Label_s>
            <DropdownInput
              field="type"
              options={property['leasetypedetail']?.map(opt => { return {'label': opt.name, 'value': opt.name}})}
              value={data['type']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Renewal Type</Label_s>
            <DropdownInput
              field="renewalType"
              options={['Weighted', 'Renew', 'Vacate', 'None']}
              value={data['renewalType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Market Lease</Label_s>
            <DropdownInput
              field="marketLease"
              options={marketLeaseData.map(option => { return { label: option['code'], value: Number(option['marketleaseid']) }})}
              value={data['marketLease']}
              persist={persist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Revenue</H4>
        <hr />
        <div>
          <div>
            <Label_s>Rent: Amt Type</Label_s>
            <DropdownInput
              field="rentAmtType"
              options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr', '% of Market'].map(opt => { return { label: opt, value: opt }})}
              value={data['rentAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Rent: Increase</Label_s>
            <DropdownInput
              field="increase"
              options={increaseData.map(option => { return { label: option['code'], value: Number(option['increaseid']) }})}
              value={data['increase']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Free Rent: Amt Type</Label_s>
            <DropdownInput
              field="freeRentAmtType"
              options={['Mos','Mos/Yr'].map(opt => { return { label: opt, value: opt }})}
              value={data['freeRentAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Free Rent: Revenue</Label_s>
            <DropdownInput
              field="freeRentRevenue"
              options={['Rent', 'Rent + Recovery', 'All Revenues'].map(opt => { return { label: opt, value: opt }})}
              value={data['freeRentRevenue']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Misc Revenue: Amt Type</Label_s>
            <DropdownInput
              field="miscRevenueAmtType"
              options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr'].map(opt => { return { label: opt, value: opt }})}
              value={data['miscRevenueAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Tenant Capital</H4>
        <hr />
        <div>
          <div>
            <Label_s>TI: Amt Type</Label_s>
            <DropdownInput
              field="tiAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ].map(opt => { return { label: opt, value: opt }})}
              value={data['tiAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>TI: Payout</Label_s>
            <DropdownInput
              field="tiPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['tiPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>LC: Amt Type</Label_s>
            <DropdownInput
              field="lcAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ].map(opt => { return { label: opt, value: opt }})}
              value={data['lcAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>LC: Payout</Label_s>
            <DropdownInput
              field="lcPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['lcPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Other Capital: Amt Type</Label_s>
            <DropdownInput
              field="ocAmtType"
              options={[
                'Amt',
                'Amt/Area',
                '% of Rent',
                '% of Rent + Recovery',
                '% of Rent: Ignore Free',
                '% of Rent + Recovery: Ignore Free',
                '% of All Revenues'
              ].map(opt => { return { label: opt, value: opt }})}
              value={data['ocAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Other Capital: Payout</Label_s>
            <DropdownInput
              field="ocPayout.payoutNamedItemId"
              options={payoutData.map(option => { return { label: option['code'], value: option['payoutid'] }})}
              value={data['ocPayout']['payoutNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
      <div>
        <H4>Retail</H4>
        <hr />
        <div>
          <div>
            <Label_s>Sales: Amt Type</Label_s>
            <DropdownInput
              field="salesAmtType"
              options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
              value={data['salesAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Sales: Inflation</Label_s>
            <DropdownInput
              field="salesInflation.inflationNamedItemId"
              options={inflationData.map(option => { return { label: option['code'], value: option['inflationid'] }})}
              value={data['salesInflation']['inflationNamedItemId']}
              persist={namedItemPersist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Breakpoint: Amt Type</Label_s>
            <DropdownInput
              field="breakpointAmtType"
              options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
              value={data['breakpointAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
          <div>
            <Label_s>Overage: Amt Type</Label_s>
            <DropdownInput
              field="overageAmtType"
              options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
              value={data['overageAmtType']}
              persist={persist}
              attrs={attrs}
            />
          </div>
        </div>
      </div>
    </Defaults_s>
  ) : null
}

export default DefaultsRentRoll

